import script from "./Areas.vue?vue&type=script&lang=ts"
export * from "./Areas.vue?vue&type=script&lang=ts"

export default script